import axios from 'axios';
import { LoginRequest, LoginResponse, Request, Counterparty } from '../types';

// Базовый URL API (будет настраиваться в зависимости от окружения)
const API_BASE_URL = import.meta.env.VITE_API_URL || 'https://platform.wt-network.com/api';

// Создаем экземпляр axios
const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Интерцептор для добавления токена к запросам
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('counterparty_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Интерцептор для обработки ошибок
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Токен истек или недействителен
      localStorage.removeItem('counterparty_token');
      localStorage.removeItem('counterparty');
      window.location.href = '/counterparty/login';
    }
    return Promise.reject(error);
  }
);

// API методы для контрагента
export const counterpartyApi = {
  // Авторизация
  login: async (credentials: LoginRequest): Promise<LoginResponse> => {
    const response = await api.post('/counterparty/login', credentials);
    return response.data;
  },

  // Получение информации о контрагенте
  getProfile: async (): Promise<Counterparty> => {
    const response = await api.get('/counterparty/profile');
    return response.data;
  },

  // Получение заявок контрагента
  getRequests: async (): Promise<Request[]> => {
    const response = await api.get('/counterparty/requests');
    return response.data.data || response.data || [];
  },

  // Взять заявку в работу
  takeRequest: async (requestId: number): Promise<void> => {
    await api.post(`/counterparty/requests/${requestId}/take`);
  },

  // Подтвердить заявку
  confirmRequest: async (requestId: number): Promise<void> => {
    await api.post(`/counterparty/requests/${requestId}/confirm`);
  },

  // Отклонить заявку
  rejectRequest: async (requestId: number, comment?: string): Promise<void> => {
    const data = { 
      comment: comment || ""
    };
    await api.post(`/counterparty/requests/${requestId}/reject`, data);
  },

  // Получить детали заявки
  getRequestDetails: async (requestId: number): Promise<Request> => {
    const response = await api.get(`/counterparty/requests/${requestId}`);
    return response.data;
  },
};

export default api;
